import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import css from 'page/catalog/BasicWelcomePage/salaris/SpecialButton.module.scss'
import { SPECIAL } from 'page/catalog/BasicWelcomePage/salaris/util'
import LeftSvg from 'page/catalog/BasicWelcomePage/salaris/zarina-left.svg'
import RightSvg from 'page/catalog/BasicWelcomePage/salaris/zarina-right.svg'
import { demo } from 'page/catalog/store/CatalogStore'

export const SpecialButton = observer(() => {
  const onClick = useLatestCallback(() => {
    demo.it.startBasic(SPECIAL)
  })

  return <Space className={css.button} gap={16} center onClick={onClick}>
    <LeftSvg />
    <RightSvg />
    <Vertical gap={4} center>
      <Typo size={16} one semi>
        СПЕЦПРОЕКТ
      </Typo>
      <Typo size={32} one semi>
        2MOOD
      </Typo>
    </Vertical>
  </Space>
})
